import React from 'react';
import { motion } from 'framer-motion';
export function ExpertCare() {
  return <section className="py-24 lg:py-32 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-33">
      {/* Left Image */}
      <motion.div initial={{
      opacity: 0,
      x: -30
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="flex-1 w-full relative" data-id="element-34">
        <div className="relative aspect-[3/4] w-full max-w-md mx-auto lg:mr-auto lg:ml-0 overflow-hidden" data-id="element-35">
          <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&q=80&w=1200" alt="Luxury Treatment Room" className="w-full h-full object-cover" data-id="element-36" />
          <div className="absolute inset-0 border-[12px] border-cream/20 pointer-events-none" data-id="element-37"></div>
        </div>
      </motion.div>

      {/* Right Content */}
      <motion.div initial={{
      opacity: 0,
      x: 30
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="flex-1 w-full" data-id="element-38">
        <h2 className="font-serif text-4xl lg:text-5xl font-light leading-tight mb-8 text-black" data-id="element-39">
          Expert Care, <br data-id="element-40" />
          <span className="italic text-taupe-dark" data-id="element-41">Every Step of the Way</span>
        </h2>

        <p className="font-sans text-black/70 leading-relaxed mb-10 text-lg" data-id="element-42">
          We are proud to work with a highly skilled and experienced team,
          dedicated to providing the highest standard of training in scar
          camouflage. Our experts bring a wealth of knowledge and hands-on
          experience, ensuring you receive the most comprehensive and effective
          education available.
        </p>

        <div className="flex flex-col gap-6 font-sans text-black/80" data-id="element-43">
          <div className="flex items-start gap-4" data-id="element-44">
            <span className="text-taupe-dark mt-1" data-id="element-45">—</span>
            <p data-id="element-46">
              Industry-leading professionals with years of hands-on experience.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-47">
            <span className="text-taupe-dark mt-1" data-id="element-48">—</span>
            <p data-id="element-49">
              Comprehensive training designed to master scar camouflage
              techniques.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-50">
            <span className="text-taupe-dark mt-1" data-id="element-51">—</span>
            <p data-id="element-52">
              Personalized guidance and support throughout your healing journey.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}